import styled from "styled-components";
import Peek from "./peek.png";

const CatPeek = styled.div`
  position: fixed;
  width: 250px;
  height: 135px;
  background-image: url(${Peek});
  background-size: 250px;
  background-repeat: no-repeat;
  background-position-y: 135px;
  pointer-events: none;
  animation-name: cat-peek;
  animation-duration: 120s;
  animation-timing-function: ease;
  animation-iteration-count: infinite;
  z-index: 30;

  @keyframes cat-peek {
    0%   { background-position-y: 135px; }
    49%  { background-position-y: 135px; }
    50%  { background-position-y: 0px; }
    51%  { background-position-y: 135px; }
    100% { background-position-y: 135px; }
  }
`;

export const CatPeekBottom = styled(CatPeek)`
  left: calc(50% - 125px);
  bottom: 0;
`;

export const CatPeekRight = styled(CatPeek)`
  transform: rotate(-90deg);
  transform-origin: bottom right;
  top: calc(50% - 125px);
  right: 0;
  animation-delay: 30s;
`;
